import type { Client } from "../types";
import { ClientEdit } from "./ClientEdit";
import { ClientList } from "./ClientList";
import { ClientShow } from "./ClientShow";

export default {
  list: ClientList,
  show: ClientShow,
  edit: ClientEdit,
  recordRepresentation: (record: Client) => record.name,
};
